// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simulator {
    padding: 20px;
    font-family: Arial, sans-serif;
    max-width: 1000px; /* Increased width for more space */
    margin: 0 auto;
}

h1 {
    text-align: center;
    color: #333;
}

.program-selection {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
}

.program-selection select {
    padding: 10px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: white;
    width: 48%;
}

.search-box {
    margin-bottom: 20px;
    position: relative;
}

#search-input {
    width: 100%;
    padding: 10px;
    border: 2px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
}

#search-results {
    margin-top: 10px;
    max-height: 200px;
    overflow-y: auto;
    border: 1px solid #ddd;
    background-color: #ffffff;
    border-radius: 4px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.course-result {
    padding: 10px;
    cursor: pointer;
    border-bottom: 1px solid #eee;
    transition: background-color 0.3s ease;
    color: #333;
}

.course-result:hover {
    background-color: #f5f5f5;
}

.requirements {
    margin-top: 30px;
}

.requirements h2 {
    color: #2c3e50;
    border-bottom: 2px solid #3498db;
    padding-bottom: 10px;
    margin-bottom: 20px;
}

.requirement {
    margin-bottom: 30px;
    background-color: #f9f9f9;
    padding: 15px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.requirement h3 {
    color: #2c3e50;
    margin-bottom: 10px;
}

.requirement p {
    margin-bottom: 10px;
    color: #34495e;
}

.category {
    margin-left: 20px;
    margin-bottom: 10px;
}

.category h4 {
    font-size: 16px;
    color: #2980b9;
    margin-bottom: 5px;
}

.category p {
    font-size: 14px;
    margin-left: 10px;
    color: #555;
}

.course-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 10px;
}

.course-tag {
    display: inline-flex;
    align-items: center;
    background-color: #e0e0e0;
    border-radius: 4px;
    padding: 6px 12px;
    font-size: 0.9em;
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    transition: background-color 0.2s ease;
}

.course-tag:hover {
    background-color: #d1d1d1;
}

.course-tag button {
    background: none;
    border: none;
    color: #888;
    cursor: pointer;
    font-size: 1.1em;
    margin-left: 8px;
    padding: 0;
}

.course-tag button:hover {
    color: #333;
}

.loading, .error {
    text-align: center;
    margin-top: 10px;
    font-style: italic;
}

.error {
    color: #e74c3c;
}

.rest-section {
    margin-top: 20px;
}

.junior-core-categories {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
}`, "",{"version":3,"sources":["webpack://./src/Simulator.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB,EAAE,mCAAmC;IACtD,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,eAAe;IACf,6BAA6B;IAC7B,sCAAsC;IACtC,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb","sourcesContent":[".simulator {\n    padding: 20px;\n    font-family: Arial, sans-serif;\n    max-width: 1000px; /* Increased width for more space */\n    margin: 0 auto;\n}\n\nh1 {\n    text-align: center;\n    color: #333;\n}\n\n.program-selection {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 20px;\n}\n\n.program-selection select {\n    padding: 10px;\n    font-size: 16px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    background-color: white;\n    width: 48%;\n}\n\n.search-box {\n    margin-bottom: 20px;\n    position: relative;\n}\n\n#search-input {\n    width: 100%;\n    padding: 10px;\n    border: 2px solid #ccc;\n    border-radius: 4px;\n    font-size: 16px;\n}\n\n#search-results {\n    margin-top: 10px;\n    max-height: 200px;\n    overflow-y: auto;\n    border: 1px solid #ddd;\n    background-color: #ffffff;\n    border-radius: 4px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.course-result {\n    padding: 10px;\n    cursor: pointer;\n    border-bottom: 1px solid #eee;\n    transition: background-color 0.3s ease;\n    color: #333;\n}\n\n.course-result:hover {\n    background-color: #f5f5f5;\n}\n\n.requirements {\n    margin-top: 30px;\n}\n\n.requirements h2 {\n    color: #2c3e50;\n    border-bottom: 2px solid #3498db;\n    padding-bottom: 10px;\n    margin-bottom: 20px;\n}\n\n.requirement {\n    margin-bottom: 30px;\n    background-color: #f9f9f9;\n    padding: 15px;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.requirement h3 {\n    color: #2c3e50;\n    margin-bottom: 10px;\n}\n\n.requirement p {\n    margin-bottom: 10px;\n    color: #34495e;\n}\n\n.category {\n    margin-left: 20px;\n    margin-bottom: 10px;\n}\n\n.category h4 {\n    font-size: 16px;\n    color: #2980b9;\n    margin-bottom: 5px;\n}\n\n.category p {\n    font-size: 14px;\n    margin-left: 10px;\n    color: #555;\n}\n\n.course-tags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    margin-top: 10px;\n}\n\n.course-tag {\n    display: inline-flex;\n    align-items: center;\n    background-color: #e0e0e0;\n    border-radius: 4px;\n    padding: 6px 12px;\n    font-size: 0.9em;\n    max-width: 100%;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    transition: background-color 0.2s ease;\n}\n\n.course-tag:hover {\n    background-color: #d1d1d1;\n}\n\n.course-tag button {\n    background: none;\n    border: none;\n    color: #888;\n    cursor: pointer;\n    font-size: 1.1em;\n    margin-left: 8px;\n    padding: 0;\n}\n\n.course-tag button:hover {\n    color: #333;\n}\n\n.loading, .error {\n    text-align: center;\n    margin-top: 10px;\n    font-style: italic;\n}\n\n.error {\n    color: #e74c3c;\n}\n\n.rest-section {\n    margin-top: 20px;\n}\n\n.junior-core-categories {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
